import * as Actions from '../actions';
import { shuffleArray } from 'main/components/helpers';
import { reorderArray, swapArray } from 'main/components/helpers';

const initialState = {
    currentQuiz: {
        header: {
            quiz_id: 0,
            DisplayOrder: 0,
            QuizName: '',
            QuizDescription: '',
            TotalScore: 100,
            MinScore: 0,
            MaxAttempt: 0,
            TimeLimit: 0,
            Active: 1,
            RandomizeQuestionOrder: 1,
            IsRequired: 0,
            CreateAuthID: 0,
            LastEditAuthID: 0,
            CreationDate: '',
            LastEditDate: '',
            auto_calc_points: 1,
            IsLocked: 0,
            LockedByAuthID: 0,
        },
        labels: [],
        questionList: [],
        newAnswerCount: 0,
        newQuestionCount: 0,
    },
    event_usage: {
        event_list: [],
        is_event_used: false,
    },
    events: [],
    lessons: [],
    deleteAllowed: false,
    copiedQuiz: false,
    editInfo: {
        CreateAuthEmail: 0,
        LastEditAuthEmail: 0,
        CreationDate: '',
        LastEditDate: ''
    },
    quizList: [],
    listLoaded: false,
    quizListLoadedAfterSave: true,
    quizListSearchable: {
        companies: [],
        labels: [],
        courses: [],
        lessons: []
    },
    NewQuizName: '',
    repullQuiz: false,
    companies: [],
    allCompanies: [],
    companySearch: ''
}

const initialQuestionState = {
    header: {
        question_id: 0,
        DisplayOrder: 0,
        QuestionText: '',
        Score: 0,
        question_type_id: 1,
        RandomizeAnswerOrder: 0,
    },
    answerList: [],
    correctList: [],
    wrongList: [],
    isOpen: false,
    image: {
        asset_id: 0,
        AssetName: '',
        URL: '',
        shape_list: [],
    },
}

const initialAnswerState = {
    header: {
        answer_id: 0,
        question_id: 0,
        DisplayOrder: 0,
        AnswerText: '',
        AuthAnswer: '',
        Correct: 0,
        CorrectOrder: 0,
        xStart: 0,
        yStart: 0,
        xEnd: 0,
        yEnd: 0,
        ShapeType: ''
    },
}

// Given array of objects with object.header.DisplayOrder field
// Recalculates the DisplayOrder based on current array order
const recalcDisplayOrder = (array) => {
    return array.map((row, index) => {
        return {
            ...row,
            header: {
                ...row.header,
                DisplayOrder: (index + 1),
            }
        }
    })
}

const quizReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_QUIZ):
            {
                const { quiz, events, event_usage, lessons, deleteAllowed, NewQuizName, copiedQuiz } = action.payload;
                if (!action.payload.quiz) {
                    return { ...initialState }
                }

                return {
                    ...initialState,
                    currentQuiz: {
                        ...initialState.currentQuiz,
                        ...quiz,
                        labels: quiz.header.labels
                    },
                    events: events,
                    event_usage: event_usage,
                    lessons: lessons,
                    deleteAllowed: deleteAllowed,
                    NewQuizName: quiz.header.QuizName + ' - Copy',
                    copiedQuiz: copiedQuiz,
                    companies: action.payload.companies,
                    allCompanies: action.payload.allCompanies
                };
            }
        case (Actions.ACTIVATE_QUIZ):
            {
                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        header: {
                            ...state.currentQuiz.header,
                            Active: 1
                        }
                    }
                }
            }

        case (Actions.GET_EDIT_INFO):
            {
                return {
                    ...state,
                    editInfo: action.payload
                }
            }

        case (Actions.UPDATE_QUIZ_FORM):
            {
                const quiz_data = action.payload;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        header: {
                            ...state.currentQuiz.header,
                            ...quiz_data
                        }
                    }
                }
            }
        case (Actions.UPDATE_QUIZ_LABELS):
            {
                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        ...action.payload
                    }
                }
            }
        case (Actions.TOGGLE_COMPANY):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCompany = state.allCompanies.filter((c) => c.id === action.payload.company.id)
                    return {
                        ...state,
                        companies: state.companies.concat(newCompany)
                    }
                }
                else {
                    return {
                        ...state,
                        companies: state.companies.filter((c) => c.id !== action.payload.company.id)
                    }
                }
            }
        case (Actions.COMPANY_UPDATE_SEARCH):
            {
                return {
                    ...state,
                    companySearch: action.payload
                }
            }

        case (Actions.CLEAR_QUIZ):
            {
                return {
                    ...initialState,
                    quizList: state.quizList
                };
            }

        case (Actions.GET_QUIZ_LIST):
            {
                return {
                    ...state,
                    listLoaded: true,
                    quizList: action.payload.quizList.quizList,
                    quizListSearchable: {
                        companies: action.payload.quizList.searchData.companies,
                        labels: action.payload.quizList.searchData.labels,
                        courses: action.payload.quizList.searchData.courses,
                        lessons: action.payload.quizList.searchData.lessons
                    },
                    quizListLoadedAfterSave: action.payload.call_location === 'list' ? state.quizListLoadedAfterSave : true
                };
            }
        case (Actions.UPDATE_QUIZ_LIST_LOADED):
            {
                return {
                    ...state,
                    quizListLoadedAfterSave: action.payload
                };
            }

        // ------------------------------------ QUESTION CRUD ------------------------------------ //

        // Adds blank question to currentQuiz
        case (Actions.ADD_QUESTION):
            {
                const quiz_id = action.payload;
                const newQuestionCount = state.currentQuiz.newQuestionCount + 1;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        newQuestionCount: newQuestionCount,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            return {
                                ...question,
                                isOpen: false,
                            }
                        }).concat({
                            ...initialQuestionState,
                            header: {
                                ...initialQuestionState.header,
                                quiz_id: quiz_id,
                                question_id: "new_" + newQuestionCount,
                                DisplayOrder: state.currentQuiz.questionList.length + 1,
                                RandomizeAnswerOrder: state.currentQuiz.header.RandomizeQuestionOrder
                            },
                            isOpen: true
                        }),
                    }
                }
            }

        case (Actions.UPDATE_QUESTION):
            {
                const question_id = action.payload.question_id;
                const question_data = action.payload.question_data;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    header: {
                                        ...question.header,
                                        ...question_data
                                    }
                                };
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.DELETE_QUESTION):
            {
                const question_id = action.payload;

                let newQuestionList = state.currentQuiz.questionList.filter((question) => question.header.question_id !== question_id);

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: recalcDisplayOrder(newQuestionList)
                    }
                }
            }

        case (Actions.MOVE_QUESTION):
            {
                const direction = action.payload.direction;
                const display_order = action.payload.display_order;

                let newQuestionList = state.currentQuiz.questionList;
                let max_display_order = Math.max.apply(Math, newQuestionList.map(function (question) { return question.header.DisplayOrder; }));

                // Handles upper/lower limits when shifting questions around
                if (direction === 'UP') {
                    if (display_order - 1 <= max_display_order && display_order - 1 > 0) {
                        newQuestionList = state.currentQuiz.questionList.map((question) => {
                            if (question.header.DisplayOrder === display_order - 1) {
                                return { ...question, header: { ...question.header, DisplayOrder: question.header.DisplayOrder + 1 } };
                            } else if (question.header.DisplayOrder === display_order) {
                                return { ...question, header: { ...question.header, DisplayOrder: question.header.DisplayOrder - 1 } };
                            } else {
                                return question;
                            }
                        });
                    }
                } else {
                    if (display_order + 1 <= max_display_order && display_order + 1 > 0) {
                        newQuestionList = state.currentQuiz.questionList.map((question) => {
                            if (question.header.DisplayOrder === display_order + 1) {
                                return { ...question, header: { ...question.header, DisplayOrder: question.header.DisplayOrder - 1 } };
                            } else if (question.header.DisplayOrder === display_order) {
                                return { ...question, header: { ...question.header, DisplayOrder: question.header.DisplayOrder + 1 } };
                            } else {
                                return question;
                            }
                        });
                    }
                }

                newQuestionList = newQuestionList.sort((a, b) => a.header.DisplayOrder - b.header.DisplayOrder);

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: newQuestionList
                    }
                }
            }

        // ------------------------------------ ANSWER CRUD ------------------------------------ //


        // Adds blank answer object to specified question_id
        case (Actions.ADD_ANSWER):
            {
                const question_id = action.payload;
                const newAnswerCount = state.currentQuiz.newAnswerCount + 1;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        newAnswerCount: newAnswerCount,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                const newAnswer = {
                                    ...initialAnswerState,
                                    header: {
                                        ...initialAnswerState.header,
                                        question_id: question_id,
                                        answer_id: "new_" + newAnswerCount,
                                        DisplayOrder: question.answerList.length + 1,
                                    }
                                }

                                return {
                                    ...question,
                                    answerList: question.answerList.concat(newAnswer),
                                    wrongList: question.wrongList.concat(newAnswer),
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }

            }

        case (Actions.UPDATE_ANSWER):
            {
                const answer_data = action.payload.answer_data;
                const answer_id = action.payload.answer_id;
                const question_id = action.payload.question_id;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                if (question.header.question_type_id === 5) { // Ordered Answers
                                    return {
                                        ...question,
                                        correctList: question.correctList.map((answer) => {
                                            if (answer.header.answer_id === answer_id) {
                                                return {
                                                    ...answer,
                                                    header: {
                                                        ...answer.header,
                                                        ...answer_data,
                                                    }
                                                }
                                            } else {
                                                return answer;
                                            }
                                        }),
                                        wrongList: question.wrongList.map((answer) => {
                                            if (answer.header.answer_id === answer_id) {
                                                return {
                                                    ...answer,
                                                    header: {
                                                        ...answer.header,
                                                        ...answer_data,
                                                    }
                                                }
                                            } else {
                                                return answer;
                                            }
                                        })
                                    }
                                } else {
                                    return {
                                        ...question,
                                        answerList: question.answerList.map((answer) => {
                                            if (answer.header.answer_id === answer_id) {
                                                return {
                                                    ...answer,
                                                    header: {
                                                        ...answer.header,
                                                        ...answer_data
                                                    }
                                                };
                                            } else {
                                                // If selecting correct answer when MultipleChoice, uncheck all other Answers
                                                if (typeof answer_data['Correct'] !== 'undefined' && question.header.question_type_id === 1 /* MultipleChoice */) {
                                                    return {
                                                        ...answer,
                                                        header: {
                                                            ...answer.header,
                                                            Correct: 0
                                                        }
                                                    }
                                                }
                                                return answer;
                                            }
                                        })
                                    }
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.DELETE_ANSWER):
            {
                const answer_id = action.payload.answer_id;
                const question_id = action.payload.question_id;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    answerList: recalcDisplayOrder(question.answerList.filter((answer) => answer.header.answer_id !== answer_id)),
                                    correctList: question.correctList.filter((answer) => answer.header.answer_id !== answer_id),
                                    wrongList: question.wrongList.filter((answer) => answer.header.answer_id !== answer_id),
                                };
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.MOVE_ANSWER):
            {
                const question_id = action.payload.question_id;
                const direction = action.payload.direction;
                const display_order = action.payload.display_order;

                let newAnswerList = state.currentQuiz.questionList.find((question) => question.header.question_id === question_id).answerList;
                let max_display_order = Math.max.apply(Math, newAnswerList.map(function (answer) { return answer.header.DisplayOrder; }));

                // Handles upper/lower limits when shifting answers around
                if (direction === 'UP') {
                    if (display_order - 1 <= max_display_order && display_order - 1 > 0) {
                        newAnswerList = newAnswerList.map((answer) => {
                            if (answer.header.DisplayOrder === display_order - 1) {
                                return { ...answer, header: { ...answer.header, DisplayOrder: answer.header.DisplayOrder + 1 } };
                            } else if (answer.header.DisplayOrder === display_order) {
                                return { ...answer, header: { ...answer.header, DisplayOrder: answer.header.DisplayOrder - 1 } };
                            } else {
                                return answer;
                            }
                        });
                    }
                } else {
                    if (display_order + 1 <= max_display_order && display_order + 1 > 0) {
                        newAnswerList = newAnswerList.map((answer) => {
                            if (answer.header.DisplayOrder === display_order + 1) {
                                return { ...answer, header: { ...answer.header, DisplayOrder: answer.header.DisplayOrder - 1 } };
                            } else if (answer.header.DisplayOrder === display_order) {
                                return { ...answer, header: { ...answer.header, DisplayOrder: answer.header.DisplayOrder + 1 } };
                            } else {
                                return answer;
                            }
                        });
                    }
                }

                newAnswerList = newAnswerList.sort((a, b) => a.header.DisplayOrder - b.header.DisplayOrder);

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    answerList: newAnswerList
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.ORDER_ANSWER_LIST):
            {
                const { list_type, question_id, source_index, destination_index } = action.payload;

                let current_question = state.currentQuiz.questionList.find((question) => question.header.question_id === question_id);
                let newCorrectList = current_question.correctList;
                let newWrongList = current_question.wrongList;

                if (list_type === 'wrong') {
                    newWrongList = reorderArray(newWrongList, source_index, destination_index);
                } else {
                    newCorrectList = reorderArray(newCorrectList, source_index, destination_index);
                }

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    correctList: newCorrectList,
                                    wrongList: newWrongList,
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.SWAP_ANSWER_LIST):
            {
                const { question_id, source, destination } = action.payload;

                let current_question = state.currentQuiz.questionList.find((question) => question.header.question_id === question_id);
                let newCorrectList = current_question.correctList;
                let newWrongList = current_question.wrongList;

                let result = [];
                if (source.droppableId === 'wrong') {
                    result = swapArray(newWrongList, newCorrectList, source, destination);
                } else {
                    result = swapArray(newCorrectList, newWrongList, source, destination);
                }

                newCorrectList = result['correct'];
                newWrongList = result['wrong'];

                newCorrectList = newCorrectList.map((answer) => {
                    return {
                        ...answer,
                        header: {
                            ...answer.header,
                            Correct: 1
                        }
                    }
                });

                newWrongList = newWrongList.map((answer) => {
                    return {
                        ...answer,
                        header: {
                            ...answer.header,
                            Correct: 0
                        }
                    }
                });

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    correctList: newCorrectList,
                                    wrongList: newWrongList,
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.VIEW_QUESTION):
            {
                const question_id = action.payload;
                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    isOpen: !question.isOpen
                                }
                            } else {
                                return {
                                    ...question,
                                    isOpen: false,
                                }
                            }
                        })
                    }
                }
            }

        case (Actions.CHANGE_QUESTION_TYPE):
            {
                const question_id = action.payload.question_id;
                const new_question_type_id = action.payload.question_type_id;
                const newAnswerCount = state.currentQuiz.newAnswerCount + 1;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        newAnswerCount: newAnswerCount,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                let current_question_type_id = question.header.question_type_id;

                                // If converting from MultipleChoice <=> MultipleAnswer OR LongAnswers <=> ShortAnswer keep existing answers
                                if (
                                    ((current_question_type_id === 4 || current_question_type_id === 1 || current_question_type_id === 5) && (new_question_type_id === 4 || new_question_type_id === 1 || new_question_type_id === 5))
                                    ||
                                    ((current_question_type_id === 2 || current_question_type_id === 3) && (new_question_type_id === 2 || new_question_type_id === 3))
                                ) {
                                    let first = true;

                                    let newAnswerList = question.answerList;
                                    let newCorrectList = question.correctList;
                                    let newWrongList = question.wrongList;

                                    // If switching to OrderedAnswers sync with answer list
                                    if (new_question_type_id === 5) {
                                        newCorrectList = newAnswerList.filter((answer) => answer.header.Correct === 1);
                                        newWrongList = newAnswerList.filter((answer) => answer.header.Correct === 0);
                                    }

                                    // If switching to MultipleChoice or MultipleAnswer
                                    if (new_question_type_id === 4 || new_question_type_id === 1) {
                                        // If swapping from OrderAnswer sync with current/wrong list
                                        if (current_question_type_id === 5) {
                                            newAnswerList = newCorrectList.concat(newWrongList);
                                        }

                                        // If MultipleChoice only one can be tagged as correct
                                        if (new_question_type_id === 1) {
                                            newAnswerList = newAnswerList.map((answer, index) => {
                                                if (first && answer.header.Correct === 1) {
                                                    first = false;
                                                    return answer;
                                                }

                                                return {
                                                    ...answer,
                                                    header: {
                                                        ...answer.header,
                                                        Correct: 0
                                                    }
                                                }
                                            });
                                        }
                                    }

                                    return {
                                        ...question,
                                        header: {
                                            ...question.header,
                                            question_type_id: new_question_type_id
                                        },
                                        answerList: newAnswerList,
                                        wrongList: newWrongList,
                                        correctList: newCorrectList,
                                    }
                                }

                                const newAnswer = {
                                    ...initialAnswerState,
                                    header: {
                                        ...initialAnswerState.header,
                                        answer_id: "new_" + newAnswerCount,
                                        DisplayOrder: 1,
                                        Correct: 1,
                                    }
                                };
                                // Default: Reset AnswerList to single empty answer
                                return {
                                    ...question,
                                    header: {
                                        ...question.header,
                                        question_type_id: new_question_type_id
                                    },
                                    answerList: [newAnswer],
                                    correctList: [],
                                    wrongList: [
                                        {
                                            ...newAnswer,
                                            Correct: 0
                                        }
                                    ]
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.RANDOMIZE_QUIZ):
            {
                let questionList = state.currentQuiz.questionList;
                if (state.currentQuiz.header.RandomizeQuestionOrder) {
                    questionList = shuffleArray(questionList);
                }

                questionList = questionList.map((question) => {
                    if (question.header.RandomizeAnswerOrder) {
                        return {
                            ...question,
                            answerList: shuffleArray(question.answerList)
                        }
                    } else {
                        return question;
                    }
                });

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: questionList
                    }
                }
            }

        case (Actions.UPDATE_QUESTION_IMAGE):
            {
                const { question_id, asset_id, AssetName, URL } = action.payload;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    image: {
                                        ...question.image,
                                        asset_id: asset_id,
                                        AssetName: AssetName,
                                        URL: URL,
                                    }
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.ADD_QUESTION_IMAGE_SHAPE):
            {
                const { question_id, shape_info } = action.payload;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    image: {
                                        ...question.image,
                                        shape_list: question.image.shape_list.concat(shape_info)
                                    }
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.UPDATE_QUESTION_IMAGE_SHAPE):
            {
                const { question_id, shape_info } = action.payload;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    image: {
                                        ...question.image,
                                        shape_list: question.image.shape_list.map((curr_shape) => {
                                            if (curr_shape.id === shape_info.id) {
                                                return {
                                                    ...curr_shape,
                                                    ...shape_info
                                                }
                                            } else {
                                                return curr_shape;
                                            }
                                        })
                                    }
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.REMOVE_QUESTION_IMAGE_SHAPE):
            {
                const { question_id, shape_id } = action.payload;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    image: {
                                        ...question.image,
                                        shape_list: question.image.shape_list.filter((curr_shape) => curr_shape.id !== shape_id)
                                    }
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.REPLACE_QUESTION_IMAGE_SHAPE):
            {
                const { question_id, shape_list } = action.payload;

                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question) => {
                            if (question.header.question_id === question_id) {
                                return {
                                    ...question,
                                    image: {
                                        ...question.image,
                                        shape_list: shape_list,
                                    }
                                }
                            } else {
                                return question;
                            }
                        })
                    }
                }
            }

        case (Actions.UPDATE_NEW_QUIZ_NAME): {
            return {
                ...state,
                NewQuizName: action.payload
            }
        }

        case (Actions.TOGGLE_QUIZ_REPULL): {
            return {
                ...state,
                repullQuiz: action.payload
            }
        }

        case (Actions.AUTO_CALC_QUESTION_POINTS): {
            const question_id = action.payload ? action.payload.question_id : 0;
            const auto_calc_points = state.currentQuiz.header.auto_calc_points;
            let quiz_total = state.currentQuiz.header.TotalScore;
            let question_count = state.currentQuiz.questionList.length;

            if (question_id !== 0) {
                quiz_total -= state.currentQuiz.questionList.find((question_info) => (question_info.header.question_id === question_id)).header.Score;
                question_count--;
            }

            const question_total = Number(quiz_total / question_count).toFixed(1);

            if (auto_calc_points) {
                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        questionList: state.currentQuiz.questionList.map((question_info) => {
                            if (question_info.header.question_id === question_id) {
                                return question_info;
                            } else {
                                return {
                                    ...question_info,
                                    header: {
                                        ...question_info.header,
                                        Score: question_total,
                                    }
                                }
                            }
                        })
                    }
                }
            }

            return state;
        }

        case (Actions.LOCK_QUIZ):
            {
                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        header: {
                            ...state.currentQuiz.header,
                            IsLocked: 1,
                            LockedByAuthID: action.payload
                        }
                    }
                }
            }

        case (Actions.UNLOCK_QUIZ):
            {
                return {
                    ...state,
                    currentQuiz: {
                        ...state.currentQuiz,
                        header: {
                            ...state.currentQuiz.header,
                            IsLocked: 0,
                            LockedByAuthID: 0
                        }
                    }
                }
            }
        case (Actions.GET_COMPANY_LIST):
            {
                return {
                    ...state,
                    allCompanies: action.payload.map(c => {
                        return {
                            ...c,
                            label: c.CompanyName,
                            id: c.company_id
                        }
                    })
                }
            }

        default:
            {
                return state;
            }
    }
}

export default quizReducer;


// WEBPACK FOOTER //
// src/main/content/quiz/store/reducers/quiz.reducer.js